import React from 'react';
import { WalletAPIProvider } from '@ledgerhq/wallet-api-client-react';
import { WindowMessageTransport } from '@ledgerhq/wallet-api-client';
import PropTypes from 'prop-types';

export const isWalletApiMessage = (message) => {
  if (typeof message !== 'string') {
    return false;
  }

  try {
    const parsed = JSON.parse(message);

    return Boolean(parsed) && parsed.jsonrpc === '2.0';
  } catch {
    return false;
  }
};

export class FilteredWindowMessageTransport extends WindowMessageTransport {
  get onMessage() {
    return super.onMessage;
  }

  set onMessage(handler) {
    super.onMessage = handler
      ? (message) => {
          if (isWalletApiMessage(message)) {
            handler(message);
          }
        }
      : handler;
  }
}

function TransportProvider({ children }) {
  function getWalletAPITransport() {
    if (typeof window === 'undefined') {
      return {
        onMessage: undefined,
        send: () => {},
      };
    }

    const transport = new FilteredWindowMessageTransport();
    transport.connect();
    return transport;
  }

  const transport = getWalletAPITransport();

  return <WalletAPIProvider transport={transport}>{children}</WalletAPIProvider>;
}

export default TransportProvider;

TransportProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};
